import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../../../../components/Common/UI/Accordion';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { cn } from '../../../../../../utils/styles';
import { AccountManagementSubRow, INotificationType } from '../../columns';
import NotificationsSettings from './Settings';
import Checkbox from '../../../../../../components/Common/UI/Checkbox';
import ModalEditNotifications from './Modals';
import ModalPaperlessHistory from '../Modals';

interface INotificationsPreference {
  selected: AccountManagementSubRow;
}

export interface INotifyModal {
  open: boolean;
  type: 'edit' | 'history';
}

function NotificationsPreference({ selected }: INotificationsPreference) {
  const [openAccordion, setOpenAccordion] = useState<boolean>(true);
  const [data, setData] = useState<AccountManagementSubRow>();

  const [modalState, setModalState] = useState<INotifyModal>({
    type: 'edit',
    open: false,
  });

  const handleOpen = ({ open, type }: INotifyModal) => {
    setModalState({ open, type });
  };

  const handleSave = (payload: INotificationType) => {
    if (data) {
      setData({ ...data, notification: payload });
    }
  };

  useEffect(() => {
    setData(selected);
  }, [selected]);

  return (
    <div>
      <Accordion type="single" collapsible defaultValue="item-key">
        <AccordionItem key="key" value="item-key" className="p-0 border rounded-lg overflow-hidden">
          <AccordionTrigger className="p-0" onClick={() => setOpenAccordion(!openAccordion)}>
            <div
              className="flex items-center w-[405px] gap-[20px] bg-[#5582B42E] p-[10px] min-h-[64px]
            justify-between"
            >
              <div className="pl-[10px] font-bold text-primary text-[20px]">Notifications Preference</div>
              <Icons.ArrowRight
                className={cn('rotate-90', {
                  'rotate-[-90deg]': openAccordion,
                })}
              />
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid gap-[10px] p-[20px] text-[16px]">
              <div className="grid grid-cols-[100px,1fr] gap-[10px]">
                <div className="opacity-80 text-primary">Notifications:</div>
                <div className="flex items-center gap-[10px] justify-end mr-[20px]">
                  <div className="font-medium uppercase">{data?.notification}</div>
                  <NotificationsSettings handleOpen={handleOpen} />
                </div>
              </div>
              <div className="grid grid-cols-[50px,1fr] gap-[10px]">
                <div className="opacity-80 text-primary">Email:</div>
                <div className="flex items-center gap-[10px] justify-end mr-[20px]">
                  <div className="font-medium">{selected.email}</div>
                  <NotificationsSettings handleOpen={handleOpen} editOnly />
                </div>
              </div>
              {data?.notification === 'Email & SMS' ? (
                <div className="grid grid-cols-[50px,1fr] gap-[10px]">
                  <div className="opacity-80 text-primary">SMS:</div>
                  <div className="flex items-center gap-[10px] justify-end mr-[20px]">
                    <div className="font-medium">{selected.phone}</div>
                    <NotificationsSettings handleOpen={handleOpen} editOnly />
                  </div>
                </div>
              ) : null}
              <div className="flex gap-2 mt-[10px] items-center">
                <Checkbox id="attachStatement" />
                <label
                  htmlFor="attachStatement"
                  className="text-sm text-primary cursor-pointer font-medium peer-disabled:cursor-not-allowed
                  peer-disabled:opacity-70 flex items-center gap-[5px]"
                >
                  Attach Statement
                  <Icons.InfoFill className="w-[20px] h-[20px]" />
                </label>
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      {data && modalState.type === 'edit' ? (
        <ModalEditNotifications handleSave={handleSave} handleOpen={handleOpen} data={data} open={modalState.open} />
      ) : null}
      {data && modalState.type === 'history' ? (
        <ModalPaperlessHistory open={modalState.open} handleOpen={handleOpen} />
      ) : null}
    </div>
  );
}

export default NotificationsPreference;
